import * as z from "zod";

export const getReturnLogicIntegration = {
  name: "getReturnLogicIntegration" as const,
  input: z.object({}),
  output: z.object({
    returnLogicIntegration: z.optional(
      z.object({ enabled: z.boolean(), accessToken: z.string() }),
    ),
  }),
};

export type GetReturnLogicIntegrationOutput = z.infer<
  typeof getReturnLogicIntegration.output
>;

export const setReturnLogicIntegration = {
  name: "setReturnLogicIntegration" as const,
  input: z.object({
    enabled: z.boolean().optional().default(true),
    accessToken: z.string().min(1, "Access token is required"),
  }),
  output: z.object({}),
};

export const updateReturnLogicIntegration = {
  name: "updateReturnLogicIntegration" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    accessToken: z.string().min(1, "Access token is required").optional(),
  }),
  output: z.object({}),
};

export const disconnectReturnLogicIntegration = {
  name: "disconnectReturnLogicIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
